import React from 'react'
import {useMediaQuery} from '@mui/material'
import CardVisitDetailsComponent from '../../@b_components/card_visit_details/card_visit_details.component'
import BrandGetComponent from '../../@b_components/brand_get/brand_get.component'
import OrderDetailsComponent from '../../@b_components/order_details/order_details.component'
import OrderDetailModalComponent from '../../@b_components/order_details_modal/order_detail_modal.component'

const OrderDetailsContainer: React.FC = function () {
  const matches = useMediaQuery('(max-width:480px)')

  return (
    <>
      {matches && <BrandGetComponent ap_position="app_content_area" />}
      <OrderDetailsComponent />
      <CardVisitDetailsComponent />
      <OrderDetailModalComponent />
    </>
  )
}

export default OrderDetailsContainer
